import api from './api';

const PATH = '/sponsors';

const listSponsors = () => api.get(PATH);

export const SponsorService = {
  listSponsors,
} 